import React from 'react';
import { observer } from 'mobx-react';
import $decks from 'app/stores/decks/$decks';
import { FlexColumn } from 'core/components';
import { Field, InputGroup, Select, Switch, TextArea } from 'core/form';
import { TbAlignBoxLeftTop, TbSettings } from 'react-icons/tb';
import { getWidgetFields } from 'app/views/boards/panels/widget/utils';
import Section from '../../SidebarSection';

function getFieldComponent(field) {
  if (field.component) {
    return field.component;
  }
  if (field.options) {
    return Select;
  }
  if (typeof field.defaultValue === 'boolean') {
    return Switch;
  }
  return InputGroup;
}

function WidgetSettingsForm(props) {
  const { form } = props;
  const { config } = form.getValues();
  const widgetName = form.getValue('config.widgetName');
  const widgetConfig = widgetName ? $decks.widgets[widgetName] : null;
  const widgetFields = getWidgetFields(widgetName);
  const WidgetConfigForm = widgetConfig?.ConfigForm;
  const visibleFields =
    Object.keys(widgetFields).length > 0 &&
    Object.entries(widgetFields).reduce((acc, [name, field]) => (field.hidden ? acc : { ...acc, [name]: field }), {});

  const handleFormChange = ({ config: newConfig }) => {
    form.setValuesDeep({ config: newConfig });
    form.onChange({ form, formValues: form.getValues() });
  };

  return (
    <FlexColumn
      width="100%"
      height="100%"
      overflowY="auto"
      bg="cardBackground"
      className="bp4-elevation-0"
      borderRadius={6}
      style={{ scrollbarWidth: 'thin' }}
    >
      <Section title="Panel" icon={TbAlignBoxLeftTop} defaultIsOpen>
        <FlexColumn gap={1} px={2} py={1}>
          <Field name="title" m={0} placeholder={widgetConfig?.title || 'Panel title'}>
            <InputGroup />
          </Field>
          <Field name="config.description" m={0} placeholder="Optional description">
            <TextArea fill rows={2} />
          </Field>
        </FlexColumn>
      </Section>
      {(visibleFields || WidgetConfigForm) && (
        <Section title="Widget" icon={TbSettings} defaultIsOpen>
          {WidgetConfigForm && (
            <WidgetConfigForm onChange={handleFormChange} config={config} widgetize formOnly showTitle={false} />
          )}
          {!WidgetConfigForm && visibleFields && (
            <FlexColumn gap={1} px={2} py={1}>
              {Object.entries(visibleFields).map(([name, { getFieldProps, noField = false, ...field }]) => {
                const fieldProps = getFieldProps ? getFieldProps(config, { prefix: 'config' }) : {};
                const componentProps = { ...field.componentProps };
                const Component = getFieldComponent({ ...field, ...fieldProps });

                if (Component === Switch) {
                  fieldProps.showLabel = false;
                  componentProps.showFieldLabel = true;
                }

                if (noField) {
                  fieldProps.render = (renderProps) => <Component {...componentProps} {...renderProps} />;
                }

                return (
                  form.hasField(name) && (
                    <Field key={name} name={name} {...fieldProps} m={0}>
                      <Component {...componentProps} />
                    </Field>
                  )
                );
              })}
            </FlexColumn>
          )}
        </Section>
      )}
    </FlexColumn>
  );
}

export default observer(WidgetSettingsForm);
